import React from "react";
import "./StatusOverlay.scss";

import dIcon from "../../../assets/imgs/onevehicle/sp_D_icon.png";
import rIcon from "../../../assets/imgs/onevehicle/sp_R_icon.png";
import nIcon from "../../../assets/imgs/onevehicle/sp_N_icon.png";
import pIcon from "../../../assets/imgs/onevehicle/sp_P_icon.png";

import highBeamIcon from "../../../assets/imgs/onevehicle/high_beam.png";
import lowBeamIcon from "../../../assets/imgs/onevehicle/low_beam.png";
import autoBeamIcon from "../../../assets/imgs/onevehicle/auto_beam.png";

import sideBrake from "../../../assets/imgs/onevehicle/side_brake.png";
import winkerLeft from "../../../assets/imgs/onevehicle/winker_left.png";
import winkerRight from "../../../assets/imgs/onevehicle/winker_right.png";

import wireWeak from "../../../assets/imgs/onevehicle/movieAB_GuideWire_Weak.png";
import wireStrong from "../../../assets/imgs/onevehicle/movieAB_GuideWire_Strong.png";

type Props = {
  status: any;
  videoPat?: number;
  isUncontrollable?: boolean;
};

const StatusOverlay: React.FC<Props> = ({
  status,
  videoPat,
  isUncontrollable = false,
}) => {
  const speed =
    typeof status?.vl === "number"
      ? status.vl > 0
        ? (status.vl * 0.1).toFixed(1)
        : status.vl === 0
          ? 0
          : null
      : null;
  const accelerator = status?.ac;
  const brake = status?.brv;
  const getShiftIcon = () => {
    if (typeof status?.clm !== "number") return undefined;
    const shiftBits = status?.clm & 0b11; // 下位2bit
    switch (shiftBits) {
      case 0b00:
        return dIcon;
      case 0b01:
        return rIcon;
      case 0b10:
        return nIcon;
      case 0b11:
        return pIcon;
      default:
        return undefined;
    }
  };
  const getHeadLightIcon = () => {
    if (typeof status?.csh !== "number") return undefined;
    const highBeam = (status?.csh & 0b100) !== 0; // bit2
    if (highBeam) return highBeamIcon;
    const headLightBits = status?.csh & 0b11; // 下位2bit
    switch (headLightBits) {
      case 0b01:
        return lowBeamIcon;
      case 0b10:
        return autoBeamIcon;
      default:
        return undefined;
    }
  };
  const isSideBrake = () => {
    return (status?.clm & 0b100) !== 0; // bit2
  };

  const isWinkerLeft = () => {
    return (status?.clm & 0b1000) !== 0; // bit3
  };

  const isWinkerRight = () => {
    return (status?.clm & 0b10000) !== 0; // bit4
  };

  const getWireIcon = () => {
    switch (status?.err?.wrd) {
      case 1:
        return wireWeak;
      case 2:
        return wireStrong;
      default:
        return undefined;
    }
  };

  const getDriveText = () => {
    switch (status?.driveType) {
      case 1:
        return { label: "自動", color: "#00FF00" };
      case 3:
        return { label: "手動", color: "#FD8237" };
      case 8:
        return { label: "遠隔", color: "#FF00FF" };
      case 32:
        return { label: "P自", color: "#81DDF5" };
      default:
        return null;
    }
  };

  const isOVR = () => {
    return (status?.ov_rid & 0b10000) !== 0; // bit4: オーバーライド
  };

  const isRemoteDrive = status?.driveType === 8;

  const uncontrollableBand = isUncontrollable ? (
    isRemoteDrive ? (
      <>
        <div className="uncontrollableBand">
          <span>操縦不能</span>
          <span>操縦不能</span>
        </div>
        <div className="brakeActiveBandBackground" />
        <div className="uncontrollableBand brakeActiveBand">
          <span>！ブレーキ作動中！</span>
        </div>
      </>
    ) : (
      <div className="uncontrollableBand">
        <span>操縦不能</span>
        <span>操縦不能</span>
      </div>
    )
  ) : null;

  if (videoPat === 4) {
    return <div className="statusOverlay">{uncontrollableBand}</div>;
  }

  return (
    <div className="statusOverlay">
      {videoPat == 1 && <div className="band" />}
      {uncontrollableBand}
      <div className="accelerator">
        <label htmlFor="accelerator">SPD</label>
        <progress id="accelerator" max="100" value={accelerator}></progress>
      </div>
      <div className="brake">
        <label htmlFor="brake">BRK</label>
        <progress id="brake" max="100" value={brake}></progress>
      </div>
      {speed !== null && (
        <>
          <div className="speed">
            {speed}
            <span>km/h</span>
          </div>
        </>
      )}
      <div className="headLight">
        {getHeadLightIcon() && <img src={getHeadLightIcon()} alt="headLight" />}
      </div>
      {!isOVR() && (
        <div className="driveMode" style={{ color: getDriveText()?.color }}>
          {getDriveText()?.label}
        </div>
      )}
      {isOVR() && (
        <div className="ovr">
          <span>OVR</span>
        </div>
      )}
      <div className="shift">
        {status?.driveType === 8 && getShiftIcon() && (
          <img src={getShiftIcon()} alt="shift" />
        )}
      </div>
      <div className="sideBrake">
        {isSideBrake() && <img src={sideBrake} alt="sideBrake" />}
      </div>
      {(isWinkerLeft() || isWinkerRight()) && (
        <div className="winker">
          <div className="winkerList">
            {isWinkerLeft() && (
              <div className="winkerLeft">
                <img src={winkerLeft} alt="left" />
              </div>
            )}
            {isWinkerRight() && (
              <div className="winkerRight">
                <img src={winkerRight} alt="right" />
              </div>
            )}
          </div>
        </div>
      )}
      <div className="wireDetect">
        {status?.driveType === 8 && getWireIcon() && (
          <img src={getWireIcon()} alt="wiredetect" />
        )}
      </div>
    </div>
  );
};

export default StatusOverlay;
